import React from 'react';
import { formatEnd } from '@/lib/offer';

// "Founding member price ₹49/month for life · 73 of 100 left · ends 30 Nov".
// Renders nothing unless the offer is genuinely open and has slots left, so it can
// never advertise something the server would refuse at checkout.
const OfferBanner = ({ offer, className = '' }) => {
  if (!offer?.open) return null;
  return (
    <div className={`rounded-2xl bg-gradient-to-r from-amber-400 to-orange-400 text-gray-900 px-4 py-3 text-center text-sm sm:text-base font-semibold shadow ${className}`} role="status">
      🎉 {offer.title}: <b>₹{offer.price_inr}/month</b> instead of ₹{offer.regular_price_inr}, locked in while you stay subscribed
      <span className="block sm:inline sm:ml-2 text-xs sm:text-sm font-medium">
        {offer.remaining} of {offer.cap} left{offer.ends_at ? ` · ends ${formatEnd(offer.ends_at)}` : ''}
      </span>
    </div>
  );
};

export default OfferBanner;
